import React from 'react';
import 'semantic-ui-css/semantic.min.css';
import ReportModelBase from './ReportModelBase';
import { Table } from '../../../node_modules/semantic-ui-react';

class AllowanceProfileReportModel extends ReportModelBase {
    constructor() {
        super();
        this.searchUrl = "api/Reports/createAllowanceProfileReport";
        this.title = "Allowance Profile Report";
        this.exportToExcelDataUrl = "api/Reports/createExportAllowanceProfileReportToExcel";
        this.exportToExcelUrl = "api/Reports/ExportAllowanceProfileReportToExcel";
        this.exportToPdfUrl = "api/Reports/createAllowanceProfileReportToPDF";
    }
    toTableRow = (rowData) => {
        return (
            <Table.Row>
                <Table.Cell>{rowData.EmployeeNo}</Table.Cell>
                <Table.Cell>{rowData.Employee}</Table.Cell>
                <Table.Cell>{rowData.AllowanceType}</Table.Cell>
                <Table.Cell>{rowData.TransactionType}</Table.Cell>
                <Table.Cell>{rowData.CutoffDate + ', Cutoff ' + rowData.CutoffNumber}</Table.Cell>
                <Table.Cell>{rowData.Amount}</Table.Cell>
            </Table.Row>
        );
    }
    createColumnHeaders = () => {
        return (
            <Table.Row>
                <Table.HeaderCell>Employee No.</Table.HeaderCell>
                <Table.HeaderCell>Employee</Table.HeaderCell>
                <Table.HeaderCell>Allowance Type</Table.HeaderCell>
                <Table.HeaderCell>Transaction Type</Table.HeaderCell>
                <Table.HeaderCell>Cutoff</Table.HeaderCell>
                <Table.HeaderCell>Amount</Table.HeaderCell>
            </Table.Row>
        );
    }
}
export default AllowanceProfileReportModel;
